import React from "react";
import IconHeader from "components/IconHeader";
import IconSubheaderUntyped from "components/IconSubheader";
import IconCircle from "components/IconCircle";
import Button from "components/Button";

// IconSubheader types `subheader` as string; this card passes a React.ReactNode,
// so widen the prop at the boundary to accept it.
const IconSubheader = IconSubheaderUntyped as React.ComponentType<{
  subheader?: React.ReactNode;
}>;

interface IconMessageCardProps {
  icon?: React.ReactNode;
  header?: string;
  subheader?: React.ReactNode;
  actionText?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  isFetching?: boolean;
  circle?: boolean;
  actionComponent?: React.ReactNode;
  color?: string;
}

const IconMessageCard = ({
  icon,
  header,
  subheader,
  actionText,
  onClick,
  isFetching,
  circle = true,
  actionComponent,
  color = "primary",
}: IconMessageCardProps) => {
  let actionContent = null;

  if (actionComponent) {
    actionContent = actionComponent;
  } else if (onClick) {
    actionContent = (
      <div className="step-btn">
        <Button
          size="sm"
          color="action"
          name="action"
          onClick={onClick}
          loading={isFetching}
        >
          {actionText}
        </Button>
      </div>
    );
  }

  return (
    <div
      style={{
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {circle && (
        <div>
          <IconCircle type={color} icon={icon} />
        </div>
      )}
      <div style={{ width: "80%", paddingTop: 15 }}>
        <IconHeader variant="cardEmptyState" headerText={header} />
        <IconSubheader subheader={subheader} />
      </div>
      <section
        style={{
          paddingTop: 10,
          paddingBottom: 20,
        }}
      >
        {actionContent}
      </section>
    </div>
  );
};

export default IconMessageCard;
